import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { RestService } from "@stdoutsrl/design-kit";
import { api, environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private transloco: TranslocoService,
    private router: Router,
    private rest: RestService
  ) {}

  disableBlurImg = false;
  isReady = false;

  ngOnInit(): void {
    this.rest.setEnviroment(environment,api)
    if(localStorage.getItem('token')){
      this.rest.setToken(localStorage.getItem('token') ?? '')
    }
    let language: any = localStorage.getItem("language");
    if (language) {
      language = JSON.parse(language);
      this.transloco.setActiveLang(language?.value ? language?.value : "it");
    } else {
      let localLanguage = { value: "it", label: "Italiano" };
      this.transloco.setActiveLang("it");
      localStorage.setItem("language", JSON.stringify(localLanguage));
    }
    this.getTheme();
    this.getAccessibility();
    if (
      !localStorage.getItem("token") &&
      window.location.pathname !== "/login" &&
      !window.location.pathname.includes('prenota') &&
      window.location.pathname !== "/payment" &&
      window.location.pathname !== "/no-payment" &&
      window.location.pathname !== "/cambia-password" &&
      window.location.pathname !== "/recupero-password" &&
      window.location.pathname !== "/registrazione"
    ) {
      this.router.navigate(["/login"]);
    }
    this.changeColors();
    this.invert();
  }

  changeColors() {
    let body = document.getElementById("body");

    if (body) {
      body.style.filter = `contrast(${localStorage.getItem(
        "colorAccessibility"
      )}%)`;
    }
  }

  invert() {
    let containerBody = document.getElementById("container-body");
    if (containerBody) {
      containerBody.style.filter = `${
        localStorage.getItem("isInverted") == "true"
          ? "invert(100%)"
          : "invert(0)"
      }`;
    }
  }

  getAccessibility() {
    let accessibility: any = localStorage.getItem("accessibility");
    if (accessibility) {
      accessibility = JSON.parse(accessibility);
      document.body.style.setProperty(
        "--small",
        12 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--normal",
        14 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--medium",
        16 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--large",
        18 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--title",
        24 * accessibility?.value + "px"
      );
    } else {
      document.body.style.setProperty("--small", 12 + "px");
      document.body.style.setProperty("--normal", 14 + "px");
      document.body.style.setProperty("--medium", 16 + "px");
      document.body.style.setProperty("--large", 18 + "px");
      document.body.style.setProperty("--title", 24 + "px");
    }
  }
  getTheme() {
    let mybar = document.getElementById("loader-bar-estetista");
    if (mybar) {
      mybar.style.width = "0px";
      setTimeout(() => {
        mybar.style.width = "250px";
        this.disableBlurImg = true;
      }, 0);
      setTimeout(() => {
        this.isReady = true;
      }, 1000);
    }

    this.rest
      .get(
        `/sale/style/by_domain/${window.origin
          .replace("http://", "")
          .replace("https://", "")}`
      )
      .subscribe({
        next: (value: any) => {
          if (value.status == false) {
            document.body.style.setProperty("--primary", "#7A6F9B");
            document.body.style.setProperty("--secondary", "#7A6F8B");
            document.body.style.setProperty("--tertiary", "#FFFFFF");
            document.body.style.setProperty("--quaternary", "#111111");
            document.body.style.setProperty(
              "--login",
              "url('../assets/logoAuth.png')"
            );
            document.body.style.setProperty(
              "--banner-login",
              "url('../../assets/login_background.png')"
            );
            document.body.style.setProperty(
              "--sidenav",
              "url('../assets/logo.png')"
            );
          } else {
            document.body.style.setProperty(
              "--primary",
              value.domainStyle.primary
            );
            document.body.style.setProperty(
              "--secondary",
              value.domainStyle.secondary
            );
            document.body.style.setProperty(
              "--tertiary",
              value.domainStyle.tertiary
            );
            document.body.style.setProperty(
              "--quaternary",
              value.domainStyle.quaternary
            );
            document.body.style.setProperty(
              "--login",
              `url(${api.baseUrl + "/" + value.domainStyle.logo_login})`
            );
            document.body.style.setProperty(
              "--banner-login",
              `url(${api.baseUrl + "/" + value.domainStyle.banner_login})`
            );
            document.body.style.setProperty(
              "--sidenav",
              `url(${api.baseUrl + "/" + value.domainStyle.logo_sidenav})`
            );
          }
          this.checkIsReady();
        },
      });
  }

  checkIsReady() {
    if (this.isReady) {
      let loaderEstetista = document.getElementById("loader-style-estetista");
      if (loaderEstetista) {
        loaderEstetista.remove();
      }
    } else {
      setTimeout(() => {
        this.checkIsReady();
      }, 100);
    }
  }
}
